/**
 * Properties reducer.
 * @module reducers/toolbar/toolbar
 */

import { GET_SITE_PROPERTIES } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  data: {},
};

/**
 * Site Properties reducer.
 * @function site
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function site_properties(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SITE_PROPERTIES}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        data: {},
      };
    case `${GET_SITE_PROPERTIES}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        data: action.result,
      };
    case `${GET_SITE_PROPERTIES}_FAIL`:
      return {
        ...state,
        error: action.result,
        loaded: false,
        loading: false,
        data: {},
      };
    default:
      return state;
  }
}
